/*
 * This file is part of glowingblue/orell-gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../common';
import { extend } from 'flarum/common/extend';
import LeaderboardListItem from 'flarum/gamilytics/forum/leaderboards/components/LeaderboardListItem';
import addLeaderboardLink from './addLeaderboardLink';
import addLeaderboardHero from './addLeaderboardHero';
import addHomeStats from './addHomeStats';

export { default as extend } from './extend';

app.initializers.add(slug, () => {
	extend(LeaderboardListItem, 'getIconMap', function (iconMap) {
		iconMap['reviews'] = 'far fa-heart';
		iconMap['ratings'] = 'far fa-heart';
		iconMap['review_comments'] = 'far fa-comment-alt';
		iconMap['bookshelves'] = 'far fa-books';
		iconMap['bookshelf_articles'] = 'far fa-book';
		iconMap['read_books'] = 'far fa-book-spells';
		iconMap['favorite_books'] = 'far fa-book-spells';
		iconMap['reading_rounds'] = 'far fa-book-heart';
		iconMap['reading_challenges'] = 'far fa-trophy';
		iconMap['review_exports'] = 'fa-kit fa-regular-cloud-circle-check';
		iconMap['article_wishlist'] = 'far fa-bookmark';
		iconMap['following_users'] = 'fa-kit fa-sharp-regular-user-group-circle-plus';
		iconMap['lurking_users'] = 'fa-kit fa-sharp-regular-user-group-circle-plus';
	});

	addLeaderboardHero();
	addLeaderboardLink();
	addHomeStats();
});
